import { dataApiUrl } from 'utils/url';
import AuthAxios from 'utils/authAxios';

const DataApiUrl = dataApiUrl();

const Codes = () => {
  const getCurrentUpcPrefix = data => AuthAxios.get(`${DataApiUrl}/admin/codes/upc`, data).then(res => res.data);

  const getCurrentIsrcPrefix = data => AuthAxios.get(`${DataApiUrl}/admin/codes/isrc`, data).then(res => res.data);

  return {
    getCurrentUpcPrefix,
    getCurrentIsrcPrefix,
  };
};

export default Codes;
